import * as React from 'react';
import cn from 'classnames';
import styles from './work-item-details.module.css';

import { WaiverWorkItemDetails, WaiverWorkItem } from '../../types/waiverWorkItem';
import sanitizeWorkItemHtml from '../../service/waiverWorkItemEmailSanitizer';
import { API_ROUTES } from '../../constants';

const getWaiverWorkItemAttachmentUrl = API_ROUTES.waiverWorkItemAttachment;

interface Props {
  workItem: WaiverWorkItem;
  workItemDetails: WaiverWorkItemDetails;
}

const WaiverEmail: React.FC<Props> = ({ workItem, workItemDetails }) => {
  return (
    <div className={cn(styles.emailContent)}>
      <div className={cn(styles.emailSubjectLine)}>
        {workItemDetails.emailSubject}
      </div>
      <div className={cn(styles.emailFromAddress)}>
        {workItemDetails.emailFromAddress}
      </div>

      <EmbededEmail workItem={workItem} workItemDetails={workItemDetails} />
      <Attachments workItem={workItem} workItemDetails={workItemDetails} />
    </div>
  );
};

const EmbededEmail: React.FC<Props> = ({ workItemDetails }) => {
  const getEmailContent = () => {
    return sanitizeWorkItemHtml(
      workItemDetails.emailBodyHtml || '',
      workItemDetails.workItemId,
    );
  };

  return (
    <div
      className={cn(styles.emailBodyEmbed)}
      dangerouslySetInnerHTML={{ __html: getEmailContent() } as any}
    />
  );
};

const Attachments: React.FC<Props> = ({ workItem, workItemDetails }) => {
  const hasAttachments =
    workItemDetails.emailAttachmentNames &&
    workItemDetails.emailAttachmentNames.length > 0;
  return hasAttachments ? (
    <>
      <div className={styles.attachmentSeparator} />
      {workItem.airlineCode ? (
        (workItemDetails.emailAttachmentNames || []).map(attachmentName => (
          <AttachmentLink
            key={attachmentName}
            workItemId={workItemDetails.workItemId}
            attachmentName={attachmentName}
          />
        ))
      ) : (
        <div className={styles.attachmentMessage}>
          Email attachments are not available for download from addresses that
          have not been associated with an airline.{' '}
        </div>
      )}
    </>
  ) : null;
};

interface AttachmentLinkProps {
  workItemId: number;
  attachmentName: string;
}

// target _self is required to prevent $location from treating this an an internal route change.
const AttachmentLink: React.FC<AttachmentLinkProps> = ({
  workItemId,
  attachmentName,
}) => (
  <a
    className={cn(styles.attachment)}
    href={getWaiverWorkItemAttachmentUrl(workItemId, attachmentName)}
    download={attachmentName}
    target="_self"
  >
    <span className={styles.attachmentLink}>{attachmentName}</span>
    <span
      className={cn(
        'glyphicon',
        'glyphicon-download-alt',
        styles.attachmentIcon,
      )}
    ></span>
  </a>
);

export default WaiverEmail;
